import PopupAlert from './PopupAlert';

export default PopupAlert;
